import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";

const styles = (theme) => ({
  footer: {
    marginTop: "10px",
    height: "50px",
    width: "100%",
    display: "flex",
    backgroundColor: "#000",
    color: "white",
    justifyContent: "center",
    alignItems: "center",
  },
  signature: {
    color: "#f44336",
    position: "absolute",
    right: "1.5rem",
  },
});

class Footer extends Component {
  render() {
    const { classes } = this.props;

    return (
      <Grid item xs={12} md={12} className={classes.footer}>
        <Typography style={{ color: "#d8d8d8", fontSize: "0.80rem" }}>
          <b>SIRET</b>: 48064494700024
        </Typography>
        <a
          className={classes.signature}
          target="_blank"
          href="http://www.angiedefiolle.com"
        >
          &lt;&#x2F;&gt;
        </a>
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js